import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const FOOTER_LINKS = [
  { path: '/about', label: 'About' },
  { path: '/stats', label: 'Stats' },
  { path: '/contact', label: 'Contact' },
  { path: '/privacy', label: 'Privacy' },
  { path: '/terms', label: 'Terms' },
  { path: '/copyright', label: 'Copyright / DMCA' },
  { path: '/sitemap.xml', label: 'Sitemap', external: true },
];

const Footer = () => {
  const location = useLocation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row align-items-center footer-row">
          <div className="col-lg-5">
            <p className="footer-tagline mb-0">
                © 2026 DarkNews — Anti-clickbait, anti-partisan; truth over theater
            </p>
          </div>
          <div className="col-lg-7 footer-aside">
            <nav className="footer-links" aria-label="Site">
              {FOOTER_LINKS.map(({ path, label, external }, index) => (
                <React.Fragment key={path}>
                  {index > 0 && (
                    <span className="footer-separator" aria-hidden="true">
                      ·
                    </span>
                  )}
                  {external ? (
                    <a href={path} className="footer-link">
                      {label}
                    </a>
                  ) : (
                    <Link
                      to={path}
                      className={`footer-link ${location.pathname === path ? 'footer-link--active' : ''}`}
                    >
                      {label}
                    </Link>
                  )}
                </React.Fragment>
              ))}
            </nav>
            <p className="footer-credit mb-0">
              Powered by Gofer <span className="gofer-icon" aria-hidden="true">📰</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
